export default __webpack_public_path__ + "static/media/ico-08.cfc39308.png";